'use strict';

import './modules';

import './includes/initFeatherlight';

import './includes/initSlick';

import './includes/initHeaderArea';

import './includes/initBodyScroll';

import './includes/initSmoothScroll';

import './includes/initAutoplayVideo';

import './includes/initBodyFade';

import './includes/initLabelEffect';

import './includes/initTopScroll';

import './includes/initInViewEffect';

import './includes/initVideoThumbailHeight';

import './includes/initSpaceBottom';
